import { useRef } from "react";

let _maskCounter = 0;

export default function LockedCardOverlay() {
  const maskId = useRef(`lock-keyhole-${++_maskCounter}`).current;
  return (
    <div style={{
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none",
      opacity: .4,
      zIndex: 2,
    }}>
      <svg
        viewBox="0 0 100 112"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        style={{ width: "auto", height: "90%" }}
      >
        <mask id={maskId}>
          <rect x="14" y="8" width="72" height="100" fill="white"/>
          <circle cx="50" cy="74" r="6" fill="black"/>
          <rect x="46" y="74" width="8" height="18" fill="black"/>
        </mask>
        <g mask={`url(#${maskId})`}>
          <path d="M33 54 L33 34 A17 17 0 0 1 67 34 L67 54" fill="none" stroke="#111111" strokeWidth="12" strokeLinecap="round"/>
          <rect x="20" y="52" width="60" height="52" rx="10" fill="#111111"/>
        </g>
      </svg>
    </div>
  );
}
